import { render, staticRenderFns } from "./P2PAutoEndTimeSetting.vue?vue&type=template&id=7897d561&scoped=true&"
import script from "./P2PAutoEndTimeSetting.vue?vue&type=script&lang=js&"
export * from "./P2PAutoEndTimeSetting.vue?vue&type=script&lang=js&"
import style0 from "./P2PAutoEndTimeSetting.vue?vue&type=style&index=0&id=7897d561&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7897d561",
  null
  
)

export default component.exports